import { render, staticRenderFns } from "./EmailLogin.vue?vue&type=template&id=09d268a5&scoped=true"
import script from "./EmailLogin.vue?vue&type=script&lang=js"
export * from "./EmailLogin.vue?vue&type=script&lang=js"
import style0 from "./EmailLogin.vue?vue&type=style&index=0&id=09d268a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d268a5",
  null
  
)

export default component.exports